'use strict';

var React = require('react');

var SvgMobilePlusMajor = function SvgMobilePlusMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 9h-6v-6a1 1 0 0 0-2 0v6h-6a1 1 0 0 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 0 0 0-2z"
  }));
};

exports.SvgMobilePlusMajor = SvgMobilePlusMajor;
